/**
 * SS Lead popup — <ss-lead-popup> ("Arrange a call back")
 *
 * Opens by trigger (delay / scroll % / exit intent on desktop / manual),
 * once per tab, never on top of the consent banner or market popup, and not
 * again for `dismissDays` after closing or `submittedDays` after a request.
 * Validates phone and postcode with the visitor's market patterns.
 * Delivery: JSON POST to the lead endpoint, or Shopify's native contact form
 * (native submit; success/errors are rendered by Shopify and re-opened here).
 * GDPR: the consent text, timestamp and page travel with the lead; the
 * dataLayer only receives a PII-free event. Opener: [data-ss-lead-popup-open].
 */
(function () {
  'use strict';
  if (customElements.get('ss-lead-popup')) return;

  var KEY = 'ss:lead-popup';
  var SESSION = 'ss:lead-popup:shown';

  function store(kind) { try { var s = window[kind]; s.setItem('__ss', '1'); s.removeItem('__ss'); return s; } catch (e) { return null; } }
  function unescape(t) { return typeof t === 'string' ? t.replace(/&(#39|quot|lt|gt|amp);/g, function (m, e) { return { '#39': "'", quot: '"', lt: '<', gt: '>', amp: '&' }[e]; }) : t; }
  function regex(p) { try { return p ? new RegExp(p) : null; } catch (e) { return null; } }

  class SsLeadPopup extends HTMLElement {
    constructor() { super(); this._l = []; }

    connectedCallback() {
      if (window.location.pathname === '/challenge') return;
      var c = this.querySelector('[data-ss-lead-config]');
      try { this.cfg = JSON.parse(c ? c.textContent : '{}'); } catch (e) { this.cfg = null; }
      if (!this.cfg) return;
      this.local = store('localStorage'); this.session = store('sessionStorage');
      this.dialog = this.querySelector('[data-ss-lead-dialog]');
      this.form = this.querySelector('[data-ss-lead-form]');
      this.bodyWrap = this.querySelector('[data-ss-lead-body-wrap]');
      this.success = this.querySelector('[data-ss-lead-success]');
      this.phone = this.querySelector('[data-ss-lead-phone]');
      this.postcode = this.querySelector('[data-ss-lead-postcode]');
      this.email = this.querySelector('[data-ss-lead-email]');
      this.consent = this.querySelector('[data-ss-lead-consent]');
      this.hp = this.querySelector('[data-ss-lead-hp]');
      this.formError = this.querySelector('[data-ss-lead-form-error]');
      this.submitBtn = this.querySelector('[data-ss-lead-submit]');
      this.submitLabel = this.querySelector('[data-ss-lead-submit-label]');
      this.phoneRe = regex(this.cfg.phonePattern);
      this.postal = this.cfg.postal || {};
      this.postalRe = regex(this.postal.pattern);
      if (this.postcode) {
        if (this.postal.maxLength) this.postcode.maxLength = this.postal.maxLength;
        if (this.postal.inputMode) this.postcode.inputMode = this.postal.inputMode;
        this.prefillPostcode();
      }

      this.querySelectorAll('[data-ss-lead-close]').forEach(function (el) { this.on(el, 'click', this.dismiss.bind(this)); }, this);
      if (this.form) this.on(this.form, 'submit', this.onSubmit.bind(this));
      [this.phone, this.postcode, this.email].forEach(function (el) { if (el) this.on(el, 'blur', function () { this.validate(el); }.bind(this)); }, this);
      this.on(document, 'keydown', this.onKeydown.bind(this));
      this.on(document, 'click', function (e) { var o = e.target.closest && e.target.closest('[data-ss-lead-popup-open]'); if (o) { e.preventDefault(); this.open(true); } }.bind(this));

      if (this.cfg.designMode) {
        this.on(document, 'shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === this.cfg.sectionId) this.open(true); }.bind(this));
        this.on(document, 'shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === this.cfg.sectionId) this.close(); }.bind(this));
        if (this.cfg.mode === 'testing') this.open(true);
        return;
      }
      /* Contact-form mode: Shopify re-renders the page after a native submit */
      if (this.querySelector('[data-ss-lead-posted]')) { this.remember(this.cfg.submittedDays); this.showSuccess(); this.open(true); return; }
      if (this.querySelector('[data-ss-lead-server-error]')) { if (this.formError) this.formError.hidden = false; this.open(true); return; }
      this.arm();
    }
    disconnectedCallback() { this._l.forEach(function (l) { l[0].removeEventListener(l[1], l[2]); }); this._l = []; clearTimeout(this._timer); }
    on(el, t, fn, o) { el.addEventListener(t, fn, o); this._l.push([el, t, fn]); }

    /* ---------- when to open ---------- */
    allowed() {
      var cfg = this.cfg;
      if (cfg.mode === 'testing') return true;
      if (navigator.webdriver) return false;
      if (cfg.trigger === 'manual') return false;
      if (cfg.hideForCustomers && cfg.isCustomer) return false;
      if (cfg.showOn === 'product' && cfg.pageType !== 'product') return false;
      var r = null; try { r = JSON.parse(this.local && this.local.getItem(KEY) || 'null'); } catch (e) {}
      if (r && r.until > Date.now()) return false;
      if (this.session && this.session.getItem(SESSION)) return false;
      return true;
    }
    arm() {
      if (!this.allowed()) return;
      var cfg = this.cfg, fire = this.tryOpen.bind(this);
      var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
      if (cfg.trigger === 'scroll') {
        var onScroll = function () {
          var h = document.documentElement.scrollHeight - window.innerHeight;
          if (h > 0 && (window.scrollY / h) * 100 >= cfg.scrollPercent) { window.removeEventListener('scroll', onScroll); fire(); }
        };
        this.on(window, 'scroll', onScroll, { passive: true });
      } else if (cfg.trigger === 'exit' && !touch) {
        var onOut = function (e) { if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', onOut); fire(); } };
        this.on(document, 'mouseout', onOut);
      } else {
        this._timer = setTimeout(fire, cfg.delay || 0);
      }
    }
    otherOverlayOpen() {
      return !!document.querySelector('ss-consent-banner.is-bar-open, ss-consent-banner:not([hidden]) [data-ss-consent-modal]:not([hidden]), ss-market-popup.is-open, promo-popup .is-active');
    }
    tryOpen() {
      if (this.otherOverlayOpen()) {
        /* wait until the visitor has answered the consent / market question */
        var retry = function () { setTimeout(this.tryOpen.bind(this), 1500); }.bind(this);
        document.addEventListener('ss:consent:update', retry, { once: true });
        document.addEventListener('ss:market-popup:close', retry, { once: true });
        return;
      }
      this.open(false);
    }

    /* ---------- dialog ---------- */
    open(manual) {
      if (this.classList.contains('is-open')) return;
      this.lastFocus = document.activeElement;
      this.removeAttribute('hidden');
      void this.dialog.offsetWidth;
      this.classList.add('is-open');
      document.body.classList.add('ss-lead-open');
      if (!manual && this.session) { try { this.session.setItem(SESSION, '1'); } catch (e) {} }
      var first = this.success && !this.success.hidden ? this.success : this.phone;
      setTimeout(function () { (first || this.dialog).focus({ preventScroll: true }); }.bind(this), 60);
      this.dispatchEvent(new CustomEvent('ss:lead-popup:open', { bubbles: true }));
    }
    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      document.body.classList.remove('ss-lead-open');
      setTimeout(function () { this.setAttribute('hidden', ''); }.bind(this), 300);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
      this.dispatchEvent(new CustomEvent('ss:lead-popup:close', { bubbles: true }));
    }
    dismiss() { if (this.success && this.success.hidden) this.remember(this.cfg.dismissDays); this.close(); }
    remember(days) {
      if (!this.local) return;
      try { this.local.setItem(KEY, JSON.stringify({ until: Date.now() + (days || 7) * 864e5 })); } catch (e) {}
    }
    showSuccess() {
      if (this.bodyWrap) this.bodyWrap.hidden = true;
      if (this.success) { this.success.hidden = false; setTimeout(function () { this.success.focus({ preventScroll: true }); }.bind(this), 60); }
    }

    /* ---------- validation ---------- */
    setError(input, bad) {
      var id = input.getAttribute('aria-describedby'), msg = id && document.getElementById(id);
      input.setAttribute('aria-invalid', bad ? 'true' : 'false');
      if (msg) msg.hidden = !bad;
      return !bad;
    }
    validate(input) {
      var v = (input.value || '').trim();
      if (input === this.phone) return this.setError(input, !v || (this.phoneRe && !this.phoneRe.test(v)) || v.replace(/\D/g, '').length < 6);
      if (input === this.postcode) return this.setError(input, !v || (this.postalRe && !this.postalRe.test(v)));
      if (input === this.email) return this.setError(input, !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v));
      return true;
    }
    validateAll() {
      var ok = true;
      [this.phone, this.postcode, this.email].forEach(function (el) { if (el && !this.validate(el)) ok = false; }, this);
      if (this.consent) {
        var cMsg = document.getElementById(this.consent.getAttribute('aria-describedby'));
        if (cMsg) cMsg.hidden = this.consent.checked;
        this.consent.setAttribute('aria-invalid', this.consent.checked ? 'false' : 'true');
        if (!this.consent.checked) ok = false;
      }
      if (!ok) { var bad = this.querySelector('[aria-invalid="true"]'); if (bad) bad.focus(); }
      return ok;
    }
    prefillPostcode() {
      /* the PDP delivery widget remembers the visitor's postcode for 30 minutes */
      try {
        var raw = this.local && this.local.getItem('ssPdpPostalCode'); if (!raw) return;
        var d = JSON.parse(raw);
        if (d && d.__ssTtl !== undefined && Date.now() > d.__ssTtl) return;
        var code = (d && typeof d === 'object') ? (d.value || d.code || '') : String(d || '');
        if (code && !this.postcode.value) this.postcode.value = code;
      } catch (e) {}
    }

    /* ---------- submit ---------- */
    onSubmit(e) {
      if (this.formError) this.formError.hidden = true;
      if (this.hp && this.hp.value) { e.preventDefault(); this.remember(this.cfg.submittedDays); this.showSuccess(); return; } /* bot */
      if (!this.validateAll()) { e.preventDefault(); return; }
      var cfg = this.cfg, s = cfg.strings || {};
      var phone = this.phone.value.trim(), postcode = this.postcode.value.trim();
      var consentAt = new Date().toISOString(), consentText = unescape(cfg.consentText || '');
      if (window.dataLayer) window.dataLayer.push({ event: 'ss_lead_submit', lead_source: 'callback_popup', page_type: cfg.pageType });

      if (cfg.deliveryMode !== 'endpoint' || !cfg.endpoint) {
        /* native Shopify contact form: put a readable summary in the message body */
        var body = this.querySelector('[data-ss-lead-body]');
        if (body) body.value = unescape(s.bodyTemplate || '').replace('%PHONE%', phone).replace('%POSTCODE%', postcode).replace('%PAGE%', window.location.href) + '\n' + consentText + ' (' + consentAt + ')';
        this.busy(true);
        return; /* let the browser submit */
      }
      e.preventDefault();
      this.busy(true);
      var payload = {
        activity_source: 'Call Back Requested',
        source: cfg.crm.source,
        lead_status: cfg.crm.leadStatus,
        source_page: window.location.href,
        phone: phone,
        postal_code: postcode,
        country: cfg.context.country,
        locale: cfg.context.locale,
        product_id: cfg.context.productId,
        product_title: cfg.context.productTitle,
        consent: { given: true, text: consentText, timestamp: consentAt, channel: 'phone' },
        submitted_at: consentAt
      };
      fetch(cfg.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload), mode: 'cors' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); })
        .then(function () { this.remember(cfg.submittedDays); this.form.reset(); this.showSuccess(); this.dispatchEvent(new CustomEvent('ss:lead-popup:submit', { bubbles: true })); }.bind(this))
        .catch(function () { if (this.formError) this.formError.hidden = false; }.bind(this))
        .then(function () { this.busy(false); }.bind(this));
    }
    busy(on) {
      if (!this.submitBtn) return;
      this.submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
      if (this.submitLabel) this.submitLabel.textContent = unescape(on ? this.cfg.strings.submitting : this.cfg.strings.submit);
    }
    onKeydown(e) {
      if (!this.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); this.dismiss(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(this.dialog.querySelectorAll('button, input:not([type="hidden"]):not([tabindex="-1"]), [href], [tabindex]:not([tabindex="-1"])'), function (el) { return !el.disabled && el.offsetParent !== null; });
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
  }
  customElements.define('ss-lead-popup', SsLeadPopup);
})();
